import React from 'react'
import { generatePath, useNavigate, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'

import Tabs from '~/components/Tabs'
import Divider from '~/components/Divider'
import { V2_PUTAWAY_DETAIL_PATH } from '~/constants/routes'
import { PUTAWAY_DETAIL_TABS } from '~/constants/tabs'

const tabs = [
  { value: PUTAWAY_DETAIL_TABS.GENERAL, label: 'General' },
  { value: PUTAWAY_DETAIL_TABS.HISTORY, label: 'History' },
]

function PutawayDetailTabs ({ value }) {
  const navigate = useNavigate()
  const { guid } = useParams()

  const onChange = (event, tab) => {
    const redirect = generatePath(V2_PUTAWAY_DETAIL_PATH, { guid, tab })
    navigate(redirect, { replace: true })
  }

  return (
    <>
      <Tabs
        tabs={tabs}
        value={value}
        onChange={onChange}
      />
      <Divider />
    </>
  )
}

PutawayDetailTabs.propTypes = {
  value: PropTypes.string.isRequired
}

export default PutawayDetailTabs
